const COVERAGE_KIT_URL = '/coveragekit/instrumentation-process.html';

const CoverageKitView = () => (
  <div className="flex h-full min-h-0 flex-1 flex-col">
    <iframe
      title="QTrace instrumentation process"
      src={COVERAGE_KIT_URL}
      className="block min-h-0 w-full flex-1 border-0 bg-white"
    />
  </div>
);

export default CoverageKitView;
